import { createApp } from 'vue';

import SignInForm from '@/components/auth/sign-in-form.vue';
import SignUpForm from '@/components/auth/sign-up-form.vue';
import '../css/application.css';

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp({
    components: { SignInForm, SignUpForm },
  });
  app.mount('#vue-auth-app');

  return app;
});
